<!-- START Hotels list -->

<card *ngIf="view.list">
    <div class="card-header-content">
        <h1>{{ view.loaders.searchHotels || view.loaders.getQuotation ? '...' : hotels.length + ' ' + yii.matchingHotels}}</h1>

        <ng-container *permissionIf="'iqbh.hotel.list.map.use'">
            <btn *ngIf="!view.loaders.searchHotels && overlays"
                 type="actionUndo"
                 (click)="toggleListMap()"
                 [value]="yii.showMap">
            </btn>
        </ng-container>
    </div>

    <div class="card-body-content">
        <ng-container *ngIf="!view.loaders.searchHotels">
            <ng-container *ngIf="view.list">
                <notification *ngIf="error.active" [type]="error.type">{{ error.message }}</notification>

                <ul *ngIf="!view.loaders.getQuotation && hotels" class="list">
                    <li *ngFor="let hotel of hotels; let odd = odd; let even = even"
                        class="list-item hoverarea"
                        [class.odd]="odd"
                        [class.even]="even"
                        [class.modified]="isModified(hotel)"
                        [class.is-not-selectable]="hotel.isNotSelectable">
                        <hotel [hotel]="getHotelProperty(hotel)"
                               [isSelectable]="!hotel.isNotSelectable"
                               [isSelectedHotel]="hotel.property === selectedQuotation?.selected || (selectedHotelKey && selectedHotelKey === hotel.property)"
                               [config]="hotelConfig"
                               [currencies]="currencies"
                               [currency]="hotel.currency"
                               (onInsert)="!hotel.isNotSelectable ? insertQuote($event): null"
                               (onGetHotelQuote)="!hotel.isNotSelectable ? getHotelQuote($event): null"
                               (onGetQuotation)="!hotel.isNotSelectable ? getQuotation($event): null">
                        </hotel>
                    </li>
                </ul>

                <loader *ngIf="view.loaders.getQuotation" [message]="yii.generateQuotation"></loader>
            </ng-container>
        </ng-container>

        <loader *ngIf="view.loaders.searchHotels" [message]="yii.hotelsLoading"></loader>
    </div>
</card>

<iqbh-map *ngIf="view.map && overlays.length > 0 && !error.active && !view.loaders.searchHotels"
          [isBatchContext]="isBatchContext"
          [currencies]="currencies"
          [configSharedHotel]="configSharedHotel"
          [selectedQuotation]="selectedQuotation"
          [overlays]="overlays"
          [loaders]="view.loaders"
          (onShowDetailsAndOffers)="getHotelQuote($event)"
          (onShowList)="toggleListMap()"
          (onChoose)="getHotelQuote($event)">
    <notification *ngIf="error.active" [type]="error.type">{{ error.message }}</notification>
</iqbh-map>
<!-- END Hotels list -->

<!-- START Details modal -->
<hotel-informations-modal #detailsModal
                          [menuDetailsItems]="menuDetailsItems"
                          [selectedQuotation]="selectedQuotation"
                          [configSharedHotel]="configSharedHotel"
                          [view]="view"
                          [config]="offerConfig"
                          [travellers]="travellers"
                          [currency]="currencies && currencies[currencyCode]"
                          [currencies]="currencies"
                          [gppErrorNotification]="modalError"
                          [isPermModalAlternative]="isPermModalAlternative"
                          [searchResultAlternatives]="searchResultAlternatives"
                          (onGetOtherRooms)="getOtherRooms($event)"
                          (onChangeRoom)="changeRoom($event)"
                          (onGetQuotation)="getQuotation($event)"></hotel-informations-modal>
<!-- END Details modal -->
